document.addEventListener("DOMContentLoaded", () => {
    const steps = document.querySelectorAll(".step");

    const handleStepVisibility = () => {
    const windowHeight = window.innerHeight;
    const scrollY = window.scrollY;

    steps.forEach(step => {
        const fadeElements = step.querySelectorAll("[data-step-fade]");
        const rect = step.getBoundingClientRect();
        const sectionTop = rect.top + scrollY;
        const sectionCenter = sectionTop + (rect.height / 2);

        // Trigger when section center passes bottom of screen
        const inView = scrollY + windowHeight >= sectionCenter;

        fadeElements.forEach((el, index) => {
        const delay = parseInt(el.dataset.delay || index, 10);
        setTimeout(() => {
            if (inView) {
            el.classList.add("active");
            } else {
            el.classList.remove("active");
            }
        }, delay * 200);
        });
    });
    };

    window.addEventListener("scroll", handleStepVisibility);
    window.addEventListener("load", handleStepVisibility);
});